/**
 * 类型定义（JSDoc + PropTypes）。应与 hogwarts_dash_reactflow/schema.py 对齐。
 * React 运行时字段为 camelCase（Python model_dump(by_alias=True)）。
 */
import PropTypes from "prop-types";

/**
 * @typedef {"kv" | "kv_simple" | "kv_assert" | "api_auth" | "api_body"
 *   | "kv_input" | "no_input"
 *   | "api_request_line" | "case_call_target" | "data_source_target"
 *   | "single_input" | "single_select"} ComponentType
 * @typedef {string} Phase  free-form；由 TestFlowEditor.phases[].value 决定
 *
 * @typedef {Object} OptionItem
 * @property {string} value
 * @property {string} name
 * @property {string} [color]
 *
 * @typedef {Object} InputFieldDef
 * @property {string} key
 * @property {string} [name]  可选 UI 标签；为空时字段可用但不显示标签
 * @property {"input"|"textarea"|"select"} [type]
 * @property {string} [placeholder]
 * @property {string} [default]
 * @property {boolean} [required]
 * @property {OptionItem[]} [options]  仅 type=select 时使用
 * @property {boolean} [monospace]  仅 type=input 时使用
 *
 * @typedef {Object} ComponentDef
 * @property {string} [name]  componentData 的 key；single_input 可省略
 * @property {string} [header]
 * @property {ComponentType} type
 * @property {string} [valueLabel]
 * @property {boolean} [required]
 * @property {string} [placeholder]  仅 single_input / single_select
 * @property {OptionItem[]} [options]  仅 single_select：下拉选项
 * @property {InputFieldDef[]} [fields]
 *
 * @typedef {Object} ActionDef
 * @property {string} icon
 * @property {string} label
 * @property {string} color
 * @property {string} bg
 * @property {boolean} [isInfo]
 * @property {boolean} [pinned]
 * @property {string} [groupLabel]
 * @property {ComponentDef[]} components
 * @property {{componentData?: Object|string}} defaults
 *
 * @typedef {Object} FlowSchema
 * @property {Record<string, ActionDef>} actions
 *
 * @typedef {Object} NodeData
 * @property {string} id
 * @property {Phase} phase
 * @property {string} action
 * @property {{x: number, y: number}} position
 * @property {Object|string} componentData
 * @property {string[]} [prev_ids]
 * @property {string[]} [next_ids]
 *
 * @typedef {Object} EdgeData
 * @property {string} [id]
 * @property {string} source
 * @property {string} target
 * @property {boolean} [animated]
 *
 * @typedef {Object} FlowGraph
 * @property {string} schema_version
 * @property {string} saved_at
 * @property {NodeData[]} nodes
 * @property {EdgeData[]} edges
 */

export const TestFlowEditorPropTypes = {
  id: PropTypes.string,
  schema: PropTypes.object.isRequired,
  initialNodes: PropTypes.array,
  initialEdges: PropTypes.array,
  isEdit: PropTypes.bool,
  phases: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  setProps: PropTypes.func,
  selectedNode: PropTypes.string,
  graph: PropTypes.string,
  saveTrigger: PropTypes.number,
};
